// @ts-nocheck

import tippy, {createSingleton, hideAll} from "tippy.js";
// Export again so that other files don't have to import another file to use it
export {hideAll};

// Sticky tooltips are dismissible, hoverable and persistent (WCAG 1.4.13).
let isStickyTooltips = true;

export const setStickyTooltips = (value) => {isStickyTooltips = value;};

// Create a wrapper for tippy's constructor so that functions can be added to
// abide accessibility guidelines (WCAG 1.4.13).
const tippyWrapper = (elements, options = {}) => {
	const baseParams = {
		// TODO: This causes issues after moving the sidebar into an iframe,
		// mainly that tooltips along the left edge (such as "Add Bookmark")
		// aren't placed correctly (the selected placement is bottom, but it's
		// placed to the right of the button..). Perhaps this can be fixed at a
		// later date, though not totally necessary.
		//
		// popperOptions: {
		// 	modifiers: [{
		// 		name:    "flip",
		// 		options: {
		// 			fallbackPlacements: ["bottom", "right"]
		// 		}
		// 	}]
		// },
		// Add aria-label on our own later, disable the default aria-describedby
		aria: {
			content:  null,
			expanded: false
		},
		plugins: [addAttributes],
		zIndex:  2147483668
	};

	const {
		/***
		 * Added with the HelpIcon (pn-www) component in mind. Useful for when
		 * you want to show/hide some kind of explanation or longer text when
		 * interacting with the reference. This way the tooltip content is
		 * accessible to screen readers (can be hovered or clicked on).
		*/
		forceSticky = false,

		/***
		 * These two props allow the tooltip to be shown only if what's
		 * displayed on the page is cut off (overflowing). Useful for letting
		 * users see the full text in the tooltip.
		 */
		overflowingClass = "",
		showOnlyIfOverflowing = false,

		onShow,

		...tippyOptions
	} = options;

	// Helper function to include overflow detection
	const onShowHelper = (instance) => {
		if (showOnlyIfOverflowing) {
			let refElem = instance.reference;

			// If an overflowing class was specified, look for it within the reference
			if (overflowingClass !== "" && !refElem.classList.contains(overflowingClass))
				refElem = refElem.querySelector(`.${overflowingClass}`);

			if (refElem.offsetWidth >= refElem.scrollWidth)
				return false;
		}

		if (onShow)
			return onShow(instance);

		return true;
	};

	if (isStickyTooltips || forceSticky) {
		// Set flag to be able to imitate tippy's "interactive: true" option, without
		// the tooltip actually being interactive.
		let isMouseLeaveEvent = false;
		const {onHide, onTrigger, onUntrigger, ...rest} = tippyOptions || {};

		return tippy(elements, {
			onMount: (instance) => {
				instance.popper.classList.add("sticky");
			},
			onShow: (instance) => {
				instance.popper.style.pointerEvents = "initial";

				return onShowHelper(instance);
			},
			onHide: (instance) => {
				if (isMouseLeaveEvent) {
					const onMouseMove = (event) => {
						const refRect = getReferenceElement(instance).getBoundingClientRect();
						const tooltipRect = instance.popper.getBoundingClientRect();

						// Try to calculate the space from the edge of the reference
						// to the far edge of the tooltip

						// Button left edge is to the left/right of tooltip
						const xMin = (refRect.x < tooltipRect.x) ? refRect.right : tooltipRect.x;

						// Button right edge is to the right/left of tooltip
						const xMax = (refRect.right > tooltipRect.right) ? refRect.right : tooltipRect.right;

						// Button top edge is higher/lower than tooltip bottom edge
						let yMin = (refRect.y < tooltipRect.y) ? yMin = refRect.bottom : yMin = tooltipRect.y;

						// Button bottom edge is lower/higher than tooltip bottom edge
						const yMax = (refRect.bottom > tooltipRect.bottom) ? refRect.y : tooltipRect.bottom;

						// If the mouse is in the space between the reference and the
						// tooltip, or over the tooltip, let it be. Otherwise, hide it.
						const xIsInBox = ((xMax >= event.x) && (xMin <= event.x));
						const yIsInBox = ((yMax >= event.y) && (yMin <= event.y));

						const isInBox = xIsInBox && yIsInBox;
						if (!isInBox) {
							instance.hide();
							document.removeEventListener("mousemove", onMouseMove);
							return;
						}

						const xIsInTooltip = ((xMax >= tooltipRect.x) && (xMin <= tooltipRect.right));
						const yIsInTooltip = ((yMax >= tooltipRect.y) && (yMin <= tooltipRect.bottom));
						if (xIsInTooltip && yIsInTooltip)
							document.removeEventListener("mousemove", onMouseMove);
					};

					document.addEventListener("mousemove", onMouseMove);

					// When the mouse leaves the tooltip, hide the tooltip
					const onMouseLeaveTooltip = (event) => {
						const onMouseMoveX = (event) => {
							const refRect = instance.reference.getBoundingClientRect();
							const tooltipRect = instance.popper.getBoundingClientRect();

							// Try to calculate the space from the edge of the reference
							// to the far edge of the tooltip

							// Button left edge is to the left/right of tooltip
							const xMin = (refRect.x < tooltipRect.x) ? refRect.x : tooltipRect.right;

							// Button right edge is to the right/left of tooltip
							const xMax = (refRect.right > tooltipRect.right) ? tooltipRect.right : refRect.right;

							// Button top edge is higher/lower than tooltip bottom edge
							let yMin = (refRect.y < tooltipRect.y) ? yMin = refRect.y : yMin = tooltipRect.bottom;

							// Button bottom edge is lower/higher than tooltip bottom edge
							const yMax = (refRect.bottom > tooltipRect.bottom) ? tooltipRect.y : refRect.bottom;

							// If the mouse is in the space between the reference and the
							// tooltip, or over the tooltip, let it be. Otherwise, hide it.
							const xIsInBox = ((xMax >= event.x) && (xMin <= event.x));
							const yIsInBox = ((yMax >= event.y) && (yMin <= event.y));

							const isInBox = xIsInBox && yIsInBox;
							if (!isInBox) {
								instance.hide();
								document.removeEventListener("mousemove", onMouseMoveX);
							}
						};
						document.addEventListener("mousemove", onMouseMoveX);

						// instance.hide();
						instance.popper.removeEventListener("mouseleave", onMouseLeaveTooltip);
					};
					// Remove their style that sets pointer-events: "none", or the
					// mouseenter event handler won't run
					instance.popper.style.pointerEvents = "initial";

					// Only add the mouseleave event handler when the mouse enters the tooltip
					instance.popper.addEventListener("mouseenter", () => {
						instance.popper.addEventListener("mouseleave", onMouseLeaveTooltip);
						document.removeEventListener("mousemove", onMouseMove);

						const onKeyDown = (event) => {
							if (event.key === "Escape")
								instance.hide();
							document.removeEventListener("keydown", onKeyDown);
						};
						document.addEventListener("keydown", onKeyDown);
					});

					isMouseLeaveEvent = false;

					// Don't hide
					return false;
				}

				if (onHide)
					return onHide(instance);

				return true;
			},
			onTrigger: (instance, event) => {
				isMouseLeaveEvent = false;

				if (onTrigger)
					onTrigger(instance, event);
			},
			onUntrigger: (instance, event) => {
				// Only proceed if the element is visible. This avoids the tooltip
				// jumping around on the screen when a rich text editor toolbar is
				// closed. (offsetParent is null if the element or its parent element
				// has display: none set)
				if (event.target.offsetParent)
					isMouseLeaveEvent = event.type === "mouseleave";

				if (onUntrigger)
					onUntrigger(instance, event);
			},
			plugins: [addAttributes, hideOnEsc],
			...baseParams,
			...rest
		});
	} else {
		return tippy(elements, {
			...baseParams,
			...tippyOptions,
			onShow: onShowHelper
		});
	}
};

export default tippyWrapper;

export const createSingletonWrapper = (instances, options = {}) => {
	const {forceSticky = false, ...tippyOptions} = options;

	return createSingleton(instances, {
		overrides: ["content", "onMount", "onShow", "onHide", "onTrigger", "onUntrigger", "zIndex"],
		...((isStickyTooltips || forceSticky) ? {plugins: [addAttributes, hideOnEsc]} : undefined),
		...tippyOptions
	});
};

// Get the reference element from a tippy instance
const getReferenceElement = (instance) => {
	// This first line is for instances in a singleton
	let ref = instance.popperInstance.state.elements.reference.contextElement;
	if (!ref)
		ref = instance.reference;

	return ref;
};

// Plugin to hide the tooltip when esc is pressed
const hideOnEsc = {
	name:         "hideOnEsc",
	defaultValue: true,
	fn(instance) {
		function onKeyDown(event) {
			if (event.key === "Escape") {
				getReferenceElement(instance).focus();
				instance.hide();
			}
		}

		return {
			onShow() {
				document.addEventListener("keydown", onKeyDown);
			},
			onHidden() {
				document.removeEventListener("keydown", onKeyDown);
			}
		};
	}
};

// Plugin to add attributes to the tooltip element
const addAttributes = {
	name:         "addAttributes",
	defaultValue: true,
	fn(instance) {
		return {
			onCreate() {
				if (instance.reference.getAttribute("aria-label") === null)
					instance.reference.setAttribute("aria-label", instance.props.content);
			},
			onShow() {
				instance.popper.setAttribute("lang", "en");
			}
		};
	}
};
